/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Appointment
 *
 * 2 = ShowroomVisit
 *
 * 3 = PostOfSaleVisit
 *
 * -1 = Handover
 */
export enum EnquiryCrmTaskTypeFilter {
  Appointment = 1,
  ShowroomVisit = 2,
  PostOfSaleVisit = 3,
  Handover = -1,
}
